import React, { useEffect } from "react";
import RateCardMaster from "./index";

// All rate cards in a pop-up, with the same list / add / edit as Rate Card Master.
// Used from the Charges Master screens; onClose lets them refresh their list.
const RateCardsPopup = ({ onClose }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Rate cards"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1040, // below the add/edit modal (1050+) and SweetAlert (1060)
        background: "rgba(15,23,42,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <div
        className="bg-white"
        style={{
          width: "min(1200px, 100%)",
          maxHeight: "90vh",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
        }}
      >
        <div className="d-flex justify-content-between align-items-center" style={{ padding: "16px 20px", borderBottom: "1px solid #f3f4f6" }}>
          <div>
            <h5 className="mb-0" style={{ fontWeight: 700, color: "#2E237F" }}>Rate cards</h5>
            <div style={{ fontSize: "12px", color: "#6b7280" }}>Create or edit rate cards here; charges use them by card type.</div>
          </div>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
        </div>
        <div style={{ overflow: "auto", padding: "8px 12px 16px" }}>
          <RateCardMaster embedded />
        </div>
      </div>
    </div>
  );
};

export default RateCardsPopup;
